/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Cli_Table_DeveloperInputs */

const en_options_cli_table_developer = /** @type {(inputs: Options_Cli_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developer`)
};

const fr_options_cli_table_developer = /** @type {(inputs: Options_Cli_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développeur`)
};

const de_options_cli_table_developer = /** @type {(inputs: Options_Cli_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwickler`)
};

const it_options_cli_table_developer = /** @type {(inputs: Options_Cli_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sviluppatore`)
};

const ru_options_cli_table_developer = /** @type {(inputs: Options_Cli_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разработчик`)
};

const es_options_cli_table_developer = /** @type {(inputs: Options_Cli_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revelador`)
};

const zh_cn2_options_cli_table_developer = /** @type {(inputs: Options_Cli_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开发者`)
};

const ja_options_cli_table_developer = /** @type {(inputs: Options_Cli_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開発者`)
};

const hi_options_cli_table_developer = /** @type {(inputs: Options_Cli_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डेवलपर`)
};

const pt_pt2_options_cli_table_developer = /** @type {(inputs: Options_Cli_Table_DeveloperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvedor`)
};

/**
* | output |
* | --- |
* | "Developer" |
*
* @param {Options_Cli_Table_DeveloperInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_table_developer = /** @type {((inputs?: Options_Cli_Table_DeveloperInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_Table_DeveloperInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_cli_table_developer(inputs)
	if (locale === "de") return de_options_cli_table_developer(inputs)
	if (locale === "it") return it_options_cli_table_developer(inputs)
	if (locale === "ru") return ru_options_cli_table_developer(inputs)
	if (locale === "es") return es_options_cli_table_developer(inputs)
	if (locale === "zh-CN") return zh_cn2_options_cli_table_developer(inputs)
	if (locale === "ja") return ja_options_cli_table_developer(inputs)
	if (locale === "hi") return hi_options_cli_table_developer(inputs)
	if (locale === "pt-PT") return pt_pt2_options_cli_table_developer(inputs)
	return en_options_cli_table_developer(inputs)
});